module.exports = __webpack_public_path__ + "static/media/supporting.09fb79d3.svg";